module.exports = __webpack_public_path__ + "img/51626494_L.19b09c3c.png";